import { render } from "./CharacterSummary.vue?vue&type=template&id=3607b3c7&scoped=true&ts=true"
import script from "./CharacterSummary.vue?vue&type=script&lang=ts"
export * from "./CharacterSummary.vue?vue&type=script&lang=ts"

import "./CharacterSummary.vue?vue&type=style&index=0&id=3607b3c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3607b3c7"]])

export default __exports__